import { REPRESENTATIVE_NAMES } from '../../constants/constantValues';

const options = {
    tipo_de_documento: [
        {
            value: 'CC',
            label: 'CÉDULA',
        },
        {
            value: 'NIT',
            label: 'IDENTIFICACIÓN TRIBUTARIA',
        },
        {
            value: 'CE',
            label: 'CÉDULA EXTRANJERÍA',
        },
    ],
    genero: [
        {
            value: 'M',
            label: 'MASCULINO',
        },
        {
            value: 'F',
            label: 'FEMENINO',
        },
    ],
    estado_civil: [
        {
            value: 'S',
            label: 'SOLTERO(A)',
        },
        {
            value: 'C',
            label: 'CASADO(A)',
        },
        {
            value: 'D',
            label: 'DIVORCIADO(A)',
        },
        {
            value: 'V',
            label: 'VIUDO(A)',
        },
        {
            value: 'U',
            label: 'UNION LIBRE',
        },
        {
            value: 'L',
            label: 'SEPARADO (A) ',
        },
    ],
    escolaridad: [
        {
            label: 'NINGUNO',
            value: 0,
        },
        {
            label: 'B. PRIMARIA',
            value: 1,
        },
        {
            label: 'B. SECUNDARIA(9)',
            value: 2,
        },
        {
            label: 'TÉCNICO PROFESIONAL',
            value: 3,
        },
        {
            label: 'TECNOLOGO',
            value: 4,
        },
        // {
        //     label: 'PREGRADO',
        //     value: 5,
        // },
        {
            label: 'PROFESIONAL',
            value: 6,
        },
        {
            label: 'MEDIA(11)',
            value: 7,
        },
    ],
    origen: [
        {
            label: 'CHAT',
            value: 0,
        },
        {
            label: 'EMAIL',
            value: 1,
        },
        {
            label: 'LLAMADA',
            value: 2,
        },
        {
            label: `USUARIO ${REPRESENTATIVE_NAMES.GENERAL_NAME} (ALIANZA|CONCESIONARIO)`,
            value: 3,
        },
        {
            label: 'WHATSAPP',
            value: 4,
        },
        {
            label: `USUARIO ${REPRESENTATIVE_NAMES.GENERAL_NAME} (EJECUTIVO ORIGINADOR)`,
            value: 6,
        },
        {
            label: `USUARIO ${REPRESENTATIVE_NAMES.GENERAL_NAME} (ALIADO DIGITAL)`,
            value: 8,
        },
        {
            label: `CROPPER`,
            value: 10,
        },
    ],
    medio: [
        {
            value: 0,
            label: 'RADIO',
        },
        {
            value: 1,
            label: 'PÁGINA WEB',
        },
        {
            value: 2,
            label: 'REDES SOCIALES',
        },
        {
            value: 3,
            label: 'TOMA DE ZONA GRUPAL',
        },
        {
            value: 4,
            label: 'CARRO VALLA/PERIFONEO',
        },
        {
            value: 5,
            label: 'CONCESIONARIO',
        },
        {
            value: 6,
            label: `EMPLEADO ${REPRESENTATIVE_NAMES.GENERAL_NAME}`,
        },
        {
            value: 7,
            label: 'REFERIDO',
        },
        {
            value: 8,
            label: 'CROPPER',
        },
    ],
    tipo_credito: [
        {
            value: 0,
            label: 'URBANO',
        },
        {
            value: 1,
            label: 'RURAL',
        },
        {
            value: 2,
            label: 'SEMI RURAL',
        },
    ],
    tipo_motocicleta: [
        {
            label: 'MOTOCICLETA',
            value: 0,
        },
    ],
    tipo_motocarro: [
        {
            label: 'MOTOCARRO',
            value: 1,
        },
    ],
    tipo_vehiculo: [
        {
            label: 'UTILITARIO',
            value: 2,
        },
        {
            label: 'CAMIÓN LIVIANO - DE 0 A 2,5 TONELADAS',
            value: 7,
        },
        {
            label: 'AUTOMÓVIL',
            value: 3,
        },
        {
            label: 'CAMPERO',
            value: 4,
        },
        {
            label: 'CAMIÓN MEDIANO - DE 2,5 A 5 TONELADAS',
            value: 5,
        },
        {
            label: 'CAMIÓN PESADO - MAYOR A 5 TONELADAS',
            value: 6,
        },
        {
            label: 'CAMIÓN PESADO - OTROS (PASAJEROS)',
            value: 8,
        },
    ],
    tipo_de_adjunto: [
        {
            value: 0,
            label: 'SOLICITUD DE CRÉDITO',
        },
        {
            value: 1,
            label: 'CÉDULA',
        },
        {
            value: 2,
            label: 'COMITÉ DE CRÉDITO',
        },
        {
            value: 3,
            label: 'FOTOS DEL CRÉDITO',
        },
        {
            value: 4,
            label: 'DOCUMENTOS ANEXOS',
        },
        {
            value: 5,
            label: 'DOCUMENTOS ADI RIESGOS',
        },
        {
            value: 19,
            label: 'DATACREDITO',
        },
        {
            value: 20,
            label: 'LEGAL CHECK',
        },
        {
            value: 21,
            label: 'TRANSUNION',
        },
        {
            value: 22,
            label: 'CONSULTA CODEUDOR',
        },
        {
            value: 23,
            label: 'CONSULTA CONYUGUE',
        },
        { value: 24, label: 'CONSULTA CODEUDOR DOS' },
        { value: 25, label: 'CONSULTA CODEUDOR TRES' },
    ],
    tipo_de_adjunto_cartera: [
        {
            value: 0,
            label: 'SOLICITUD DE CRÉDITO',
        },
        {
            value: 1,
            label: 'CÉDULA',
        },
        {
            value: 2,
            label: 'COMITÉ DE CRÉDITO',
        },
        {
            value: 3,
            label: 'FOTOS DEL CRÉDITO',
        },
        {
            value: 4,
            label: 'DOCUMENTOS ANEXOS',
        },
        {
            value: 5,
            label: 'DOCUMENTOS ADI RIESGOS',
        },
        {
            value: 6,
            label: 'PÓLIZA VIDA OBLIGATORIO',
        },
        {
            value: 7,
            label: 'PÓLIZA VOLUNTARIA',
        },
        {
            value: 8,
            label: 'PAGARE',
        },
        {
            value: 9,
            label: 'TÉRMINOS Y CONDICIONES (CARTA DE BIENVENIDA)',
        },
        {
            value: 10,
            label: 'GARANTÍAS COMUNITARIA - CONFE',
        },
        {
            value: 11,
            label: 'PÓLIZA TODO RIESGO DE LA MOTO',
        },
        {
            value: 12,
            label: 'MANDATO (PIGNORACIÓN)',
        },
        {
            value: 13,
            label: 'PÓLIZA TODO RIESGO DEL VEH',
        },
        {
            value: 14,
            label: 'FACTURA',
        },
        {
            value: 15,
            label: 'TARJETA DE PROPIEDAD (DOCUMENTOS DEL VEHÍCULO)',
        },
        {
            value: 16,
            label: 'SOAT (DOCUMENTOS DEL VEHÍCULO)',
        },
        {
            value: 17,
            label: 'CONTRATO DE GARANTÍA (PIGNORACIÓN)',
        },
        {
            value: 18,
            label: 'GARANTÍA MOBILIARIA',
        },
        {
            value: 19,
            label: 'DATACREDITO',
        },
        {
            value: 20,
            label: 'LEGAL CHECK',
        },
        {
            value: 21,
            label: 'TRANSUNION',
        },
        {
            value: 22,
            label: 'CONSULTA CODEUDOR',
        },
        {
            value: 23,
            label: 'CONSULTA CONYUGUE',
        },
        {
            value: 26,
            label: 'CONSOLIDADO DE DOCUMENTOS FIRMADOS',
        },
    ],
    tipo_de_adjunto_aliado: [
        {
            value: 0,
            label: 'SOLICITUD DE CRÉDITO',
        },
        {
            value: 1,
            label: 'CÉDULA',
        },
    ],
    tipo_de_adjunto_todos: [
        {
            value: 0,
            label: 'SOLICITUD DE CRÉDITO',
        },
        {
            value: 1,
            label: 'CÉDULA',
        },
        {
            value: 2,
            label: 'COMITÉ DE CRÉDITO',
        },
        {
            value: 3,
            label: 'FOTOS DEL CRÉDITO',
        },
        {
            value: 4,
            label: 'DOCUMENTOS ANEXOS',
        },
        {
            value: 5,
            label: 'DOCUMENTOS ADI RIESGOS',
        },
        {
            value: 6,
            label: 'PÓLIZA VIDA OBLIGATORIO',
        },
        {
            value: 7,
            label: 'PÓLIZA VOLUNTARIA',
        },
        {
            value: 8,
            label: 'PAGARE',
        },
        {
            value: 9,
            label: 'TÉRMINOS Y CONDICIONES (CARTA DE BIENVENIDA)',
        },
        {
            value: 10,
            label: 'GARANTÍAS COMUNITARIA - CONFE',
        },
        {
            value: 11,
            label: 'PÓLIZA TODO RIESGO DE LA MOTO',
        },
        {
            value: 12,
            label: 'MANDATO (PIGNORACIÓN)',
        },
        {
            value: 13,
            label: 'PÓLIZA TODO RIESGO DEL VEH',
        },
        {
            value: 14,
            label: 'FACTURA',
        },
        {
            value: 15,
            label: 'TARJETA DE PROPIEDAD (DOCUMENTOS DEL VEHÍCULO)',
        },
        {
            value: 16,
            label: 'SOAT (DOCUMENTOS DEL VEHÍCULO)',
        },
        {
            value: 17,
            label: 'CONTRATO DE GARANTÍA (PIGNORACIÓN)',
        },
        {
            value: 18,
            label: 'GARANTÍA MOBILIARIA',
        },
        {
            value: 19,
            label: 'DATACREDITO',
        },
        {
            value: 20,
            label: 'LEGAL CHECK',
        },
        {
            value: 21,
            label: 'TRANSUNION',
        },
        {
            value: 22,
            label: 'CONSULTA CODEUDOR',
        },
        {
            value: 23,
            label: 'CONSULTA CONYUGUE',
        },
        { value: 24, label: 'CONSULTA CODEUDOR DOS' },
        { value: 25, label: 'CONSULTA CODEUDOR TRES' },
        {
            value: 26,
            label: 'CONSOLIDADO DE DOCUMENTOS FIRMADOS',
        },
    ],
    tipo_referencia: [
        {
            value: 0,
            label: 'FAMILIAR',
        },
        {
            value: 1,
            label: 'PERSONAL',
        },
        {
            value: 2,
            label: 'COMERCIAL',
        },
    ],
    tipo_parentesco: [
        {
            value: 0,
            label: 'PADRE',
        },
        {
            value: 1,
            label: 'MADRE',
        },
        {
            value: 2,
            label: 'SUEGRO/A',
        },
        {
            value: 3,
            label: 'HIJO/A',
        },
        {
            value: 4,
            label: 'YERNO',
        },
        {
            value: 5,
            label: 'NUERA',
        },
        {
            value: 6,
            label: 'ABUELO/A',
        },
        {
            value: 7,
            label: 'NIETO/A',
        },
        {
            value: 8,
            label: 'HERMANO/A',
        },
        {
            value: 9,
            label: 'CUÑADO/A',
        },
        {
            value: 10,
            label: 'BISABUELO/A',
        },
        {
            value: 11,
            label: 'BISNIETO/A',
        },
        {
            value: 12,
            label: 'TIO/A',
        },
        {
            value: 13,
            label: 'PRIMO/A',
        },
        {
            value: 14,
            label: 'SOBRINO/A',
        },
        {
            value: 15,
            label: 'AMIGO/A',
        },
        {
            value: 16,
            label: 'CÓNYUGE',
        },
    ],
    estado_referencia: [
        {
            value: 0,
            label: 'NO CONTESTA',
        },
        {
            value: 1,
            label: 'CONTESTA',
        },
        {
            value: 2,
            label: 'DATOS INCORRECTOS',
        },
        {
            value: 3,
            label: 'NO LO CONOCE',
        },
        {
            value: 4,
            label: 'NO RECOMIENDA',
        },
        {
            value: 5,
            label: 'RECOMIENDA',
        },
        {
            value: 6,
            label: 'INTENTO DE CONTACTO',
        },
        {
            value: 7,
            label: 'SIN CONTACTAR',
        },
    ],
    tipo_de_pago: [
        {
            value: 0,
            label: 'PAGO POR VENTANILLA',
        },
        {
            value: 1,
            label: 'CUENTA DE AHORROS',
        },
        {
            value: 2,
            label: 'CUENTA CORRIENTE',
        },
        {
            value: 3,
            label: 'CHEQUE',
        },
        {
            value: 4,
            label: 'ALIADO',
        },
    ],
    dia_de_pago: [
        {
            value: 1,
            label: '1',
        },
        {
            value: 2,
            label: '2',
        },
        {
            value: 3,
            label: '3',
        },
        {
            value: 4,
            label: '4',
        },
        {
            value: 5,
            label: '5',
        },
        {
            value: 6,
            label: '6',
        },
        {
            value: 7,
            label: '7',
        },
        {
            value: 8,
            label: '8',
        },
        {
            value: 9,
            label: '9',
        },
        {
            value: 10,
            label: '10',
        },
        {
            value: 11,
            label: '11',
        },
        {
            value: 12,
            label: '12',
        },
        {
            value: 13,
            label: '13',
        },
        {
            value: 14,
            label: '14',
        },
        {
            value: 15,
            label: '15',
        },
        {
            value: 16,
            label: '16',
        },
        {
            value: 17,
            label: '17',
        },
        {
            value: 18,
            label: '18',
        },
        {
            value: 19,
            label: '19',
        },
        {
            value: 20,
            label: '20',
        },
        {
            value: 21,
            label: '21',
        },
    ],
    direccion: [
        {
            value: 'CALLE',
            label: 'CALLE',
        },
        {
            value: 'CARRERA',
            label: 'CARRERA',
        },
        {
            value: 'AVENIDA',
            label: 'AVENIDA',
        },
        {
            value: 'AVENIDA CARRERA',
            label: 'AVENIDA CARRERA',
        },
        {
            value: 'AVENIDA CALLE',
            label: 'AVENIDA CALLE',
        },
        {
            value: 'CIRCULAR',
            label: 'CIRCULAR',
        },
        {
            value: 'CIRCUNVALAR',
            label: 'CIRCUNVALAR',
        },
        {
            value: 'DIAGONAL',
            label: 'DIAGONAL',
        },
        {
            value: 'TRANSVERSAL',
            label: 'TRANSVERSAL',
        },
        {
            value: 'CORREGIMIENTO',
            label: 'CORREGIMIENTO',
        },
        {
            value: 'VIA',
            label: 'VÍA',
        },
        {
            value: 'VEREDA',
            label: 'VEREDA',
        },
        {
            value: 'MANZANA',
            label: 'MANZANA',
        },
    ],
    sector_economico: [
        {
            value: 0,
            label: 'AGROPECUARIO',
        },
        {
            value: 1,
            label: 'COMERCIO',
        },
        {
            value: 2,
            label: 'PRODUCTIVO',
        },
        {
            value: 3,
            label: 'SERVICIO',
        },
    ],
    tipo_local: [
        {
            value: 0,
            label: 'ARRIENDO',
        },
        {
            value: 1,
            label: 'FAMILIA',
        },
        {
            value: 2,
            label: 'PROPIO',
        },
    ],
    tipo_de_bien_raiz: [
        {
            value: 0,
            label: 'CASA',
        },
        {
            value: 1,
            label: 'APARTAMENTO',
        },
        {
            value: 2,
            label: 'FINCA',
        },
        {
            value: 3,
            label: 'LOTE',
        },
        {
            value: 4,
            label: 'LOCAL',
        },
        {
            value: 5,
            label: 'BODEGA',
        },
    ],
    meses_de_gracia: [
        { value: '0', label: 'NINGUNO' },
        { value: '1', label: '1 MES' },
        { value: '2', label: '2 MESES' },
        { value: '3', label: '3 MESES' },
        { value: '4', label: '4 MESES' },
    ],

    propuesta_inicial: [
        { value: '0', label: 'NINGUNA' },
        { value: '1', label: 'CAMBIO DE PRODUCTO' },
        { value: '2', label: 'AUMENTO DE INICIAL' },
        { value: '3', label: 'CAMBIO DE MOTO' },
        { value: '4', label: 'BAJAR MOTO' },
    ],
    causal_no_aprobado: [
        { value: '1', label: 'CAPACIDAD DE PAGO' },
        { value: '2', label: 'HABITO DE PAGO' },
        { value: '3', label: 'AUDITORIA' },
        { value: '4', label: 'FRAUDE' },
        { value: '5', label: 'MERCADO OBJETIVO' },
        { value: '6', label: 'INCONSISTENCIA EN LA INFORMACIÓN' },
        { value: '7', label: 'ACTIVIDAD NO DEMOSTRADA' },
        { value: '8', label: 'CODEUDOR IDÓNEO' },
        { value: '9', label: 'NO AUMENTO INICIAL' },
    ],
    tipo_reporte: [
        // { value: '0', label: 'GESTIÓN MESA DE AYUDA' },
        { value: '1', label: 'GESTIÓN COMITE' },
        { value: '2', label: 'GESTIÓN DESEMBOLSO' },
        { value: '3', label: 'GESTIÓN RECHAZADAS' },
        { value: '4', label: 'GESTIÓN DESISTIDAS' },
        { value: '5', label: 'ALIVIO FINANCIERO 2021' },
        { value: '6', label: 'PREPAGADOS' },
    ],

    seguro_voluntario: [
        { value: '0', label: 'SIN SEGURO' },
        // { value: '1', label: 'TIPO 1' },
        { value: '2', label: 'TIPO 2' },
    ],

    plan_seguro_sbs: [
        { value: '0', label: 'PLAN 1' },
        { value: '1', label: 'PLAN 2' },
    ],

    tipo_seguro_sbs: [
        { value: '0', label: 'SIN SEGURO' },
        { value: '1', label: 'RURAL' },
        { value: '2', label: 'URBANO' },
    ],
    calificacion: [
        { value: 'A', label: 'A' },
        // { value: 'AA', label: 'AA' },
    ],
    conoce_cliente: [
        { value: 1, label: '1 AÑO' },
        { value: 2, label: '2 AÑOS' },
        { value: 3, label: '3 AÑOS' },
        { value: 4, label: '4 AÑOS' },
        { value: 5, label: '5 AÑOS O MAS' },
    ],
    tipo_vivienda: [
        { value: 'PROPIA', label: 'PROPIA' },
        { value: 'ARRENDADA', label: 'ARRENDADA' },
        { value: 'FAMILIAR', label: 'FAMILIAR' },
    ],
    entidad_bancaria: [
        { value: 0, label: 'BANCAMIA S.A.' },
        { value: 1, label: 'BANCO AGRARIO' },
        { value: 2, label: 'BANCO AV VILLAS' },
        { value: 3, label: 'BANCO BBVA COLOMBIA' },
        { value: 4, label: 'BANCO CAJA SOCIAL' },
        { value: 5, label: 'BANCO COOPERATIVO COOPCENTRAL' },
        { value: 6, label: 'BANCO DAVIVIENDA' },
        { value: 7, label: 'BANCO DE BOGOTA' },
        { value: 8, label: 'BANCO DE OCCIDENTE' },
        { value: 9, label: 'BANCO FALABELLA' },
        { value: 10, label: 'BANCO GNB SUDAMERIS' },
        { value: 11, label: 'BANCO ITAU' },
        { value: 12, label: 'BANCO PICHINCHA S.' },
        { value: 13, label: 'BANCO POPULAR' },
        { value: 14, label: 'BANCO PROCREDIT' },
        { value: 15, label: 'BANCO SANTANDER COLOMBIA' },
        { value: 16, label: 'BANCO SERFINANZA"' },
        { value: 17, label: 'BANCOLOMBIA' },
        { value: 18, label: 'BANCOOMEVA S.A.' },
        { value: 19, label: 'CFA COOPERATIVA FINANCIERA' },
        { value: 20, label: 'CITIBANK' },
        { value: 21, label: 'COLTEFINANCIERA' },
        { value: 22, label: 'CONFIAR COOPERATIVA FINANCIERA' },
        { value: 23, label: 'COTRAFA' },
        { value: 24, label: 'DAVIPLATA' },
        { value: 25, label: 'RAPPIPAY' },
        { value: 26, label: 'SCOTIABANK COLPATRIA' },
        { value: 27, label: 'NEQUI' },
        { value: 28, label: 'OTRO' },
    ],
    direccion_principal: [
        {
            value: 0,
            label: 'NO',
        },
        {
            value: 1,
            label: 'SI',
        },
    ],
    grupo_etnico: [
        { value: '0', label: 'NINGUNO' },
        { value: '1', label: 'INDIGENA' },
        { value: '2', label: 'AFRO' },
        { value: '3', label: 'MIGRANTE' },
        // { value: '4', label: 'DESPLAZADO' },
        { value: '5', label: 'MADRE CABEZA DE HOGAR' },
        { value: '6', label: 'VÍCTIMA DE CONFLICTO' },
        { value: '7', label: 'DISCAPACIDAD COGNITIVA' },
        { value: '8', label: 'DISCAPACIDAD FÍSICA' },
    ],
    tipo_codeudor: [
        { value: 'E', label: 'EMPLEADO' },
        { value: 'I', label: 'INDEPENDIENTE' },
        { value: 'P', label: 'PENSIONADO' },
        { value: 'FR', label: 'FINCA RAÍZ' },
        { value: 'FS', label: 'FIRMA SOLIDARIA' },
    ],
    tipo_contrato_codeudor: [
        { value: '0', label: 'INDEFINIDO' },
        { value: '1', label: 'FIJO' },
        { value: '2', label: 'CONTRATISTA' },
    ],
    peps: [
        {
            value: 0,
            label: 'NO',
        },
        {
            value: 1,
            label: 'SI',
        },
    ],
    tipo_documento_persona: [
        { value: 0, label: 'FORMATO PERÍODO DE GRACIA 2021' },
        { value: 1, label: 'COMPROBANTE PERÍODO DE GRACIA 2021' },
    ],
    tipo_seguro: [
        { value: 0, label: 'SEGURO OBLIGATORIO' },
        { value: 1, label: 'SEGURO VOLUNTARIO' },
    ],

    meses_report: [
        { value: 1, label: 'ENERO' },
        { value: 2, label: 'FEBRERO' },
        { value: 3, label: 'MARZO' },
        { value: 4, label: 'ABRIL' },
        { value: 5, label: 'MAYO' },
        { value: 6, label: 'JUNIO' },
        { value: 7, label: 'JULIO' },
        { value: 8, label: 'AGOSTO' },
        { value: 9, label: 'SEPTIEMBRE' },
        { value: 10, label: 'OCTUBRE' },
        { value: 11, label: 'NOVIEMBRE' },
        { value: 12, label: 'DICIEMBRE' },
    ],
    anios_report: [
        { value: 2025, label: '2025' },
        { value: 2024, label: '2024' },
        { value: 2023, label: '2023' },
        { value: 2022, label: '2022' },
        { value: 2021, label: '2021' },
        { value: 2020, label: '2020' },
        { value: 2019, label: '2019' },
    ],
    cambiar_estado_gestion: [
        { value: 0, label: 'SIN NOVEDAD' },
        { value: 1, label: 'CLIENTE NO CONTESTA' },
        { value: 2, label: 'CLIENTE VISITADO' },
        { value: 3, label: 'DOCUMENTOS PENDIENTES' },
        { value: 4, label: 'CODEUDORES PENDIENTES' },
    ],
    tipo_servicio: [
        {
            label: 'PÚBLICO',
            value: 0,
        },
        {
            label: 'PRIVADO',
            value: 1,
        },
    ],
    tipo_reporte_anexos: [
        { value: '0', label: 'ANEXO 5' },
        { value: '1', label: 'ANEXO 7' },
        { value: '2', label: 'ANEXO 8' },
        { value: '3', label: 'ANEXO 20' },
    ],
    reportes_cierre_mes: [
        { value: '0', label: 'REPORTE EDADES CLIENTES' },
        { value: '1', label: 'REPORTE CIIU HISTORICO CREDITOS GYG' },
    ],
    vinculo_agro: [
        {
            value: 0,
            label: 'NO',
        },
        {
            value: 1,
            label: 'SI',
        },
    ],
    tipo_barrio: [
        {
            value: 'BARRIO',
            label: 'BARRIO',
        },
        {
            value: 'VEREDA',
            label: 'VEREDA',
        },
    ],
    roles_list: [
        {
            value: '2',
            label: 'MESA DE AYUDA',
        },
        {
            value: '3',
            label: 'EJECUTIVO',
        },
        {
            value: '4',
            label: 'MESA DE APROBACION',
        },
        {
            value: '5',
            label: 'APROBADOR',
        },
        {
            value: '6',
            label: 'AUXILIAR CARTERA',
        },
        {
            value: '7',
            label: 'TESORERIA',
        },
    ],
    tipo_transaccion: [
        {
            value: 0,
            label: 'AHORROS',
        },
        {
            value: 1,
            label: 'CORRIENTE',
        },
    ],
    tipo_cuenta: [
        {
            value: 'AHORRO',
            label: 'AHORRO',
        },
        {
            value: 'CORRIENTE',
            label: 'CORRIENTE',
        },
    ],
    tipo_credito_empleados: [
        {
            value: 'NUEVO',
            label: 'NUEVO',
        },
        {
            value: 'REFINANCIACION',
            label: 'REFINANCIACION',
        },
    ],
    tipo_documentos_credito_empleados: [
        {
            value: 1,
            label: 'CEDULA',
        },
        {
            value: 2,
            label: 'SOLICITUD FIRMADA',
        },
        {
            value: 3,
            label: 'SEGURO DE VIDA',
        },
        {
            value: 4,
            label: 'PAGARE',
        },
        {
            value: 5,
            label: 'AUTORIZACION DESCUENTO POR NOMINA',
        },
    ],

    estado_solicitud: [
        { value: 20, label: 'EJECUTIVO' },
        { value: 30, label: 'ANÁLISIS' },
        { value: 40, label: 'COMITÉ' },
        { value: 50, label: 'LEGALIZACIÓN' },
        { value: 60, label: 'TESORERIA' },
        { value: 70, label: 'RECHAZADA' },
        { value: 80, label: 'DESISTIDA' },
        { value: 90, label: 'DESEMBOLSADA' },
    ],
    tipo_documento_download_pdf: [
        {
            value: 1,
            label: 'PAZ Y SALVO',
        },
        // {
        //     value: 2,
        //     label: 'ESTADO CUENTA',
        // },
        // {
        //     value: 3,
        //     label: 'PRENDA',
        // },
    ],
    rol_aliado: [
        {
            value: 11,
            label: 'ALIADO',
        },
        {
            value: 25,
            label: 'ALIADO DIGITAL',
        },
    ],
    garantia_Empleado: [
        { value: 0, label: 'SIN GARANTIA' },
        { value: 1, label: 'GARANTIAS COMUNITARIAS' },
        // { value: 2, label: 'FNG' },
    ],
    tipo_reporte_garantia: [
        { value: 0, label: 'DESEMBOLSO' },
        { value: 1, label: 'CARTERA' },
        { value: 2, label: 'RECLAMACIONES' },
    ],
    case_tipo_reporte_garantia: [
        {
            value: 'RECLAMACION_CONDONACION',
            label: 'RECLAMACIÓN - CONDONACIÓN',
        },
        { value: 'CONVENCIONAL_CASTIGO', label: 'CONVENCIONAL - CASTIGO' },
    ],

    soat_motos: [
        { value: 0, label: '$0' },
        { value: 207700, label: 'MOTOS MENOS DE 100 C.C.' },
        { value: 278200, label: 'MOTOS DE 100 A 200 C.C.' },
        { value: 701300, label: 'MOTOS MAYORES 200 C.C.' },
        { value: 313800, label: 'MOTOCARRO CARGA' },
        { value: 313800, label: 'MOTOCARRO PASAJEROS' },
    ],
    soat_carga: [
        { value: 0, label: '$0' },
        { value: 818300, label: 'MENOS DE 5 TONELADAS' },
        { value: 1181000, label: 'DE 5 A 15 TONELADAS' },
        { value: 1493900, label: 'MAS DE 15 TONELADAS' },
    ],
    tipo_relacion: [
        {
            value: 0,
            label: 'CÓNYUGE',
        },
        {
            value: 1,
            label: 'CODEUDOR',
        },
    ],

    tipo_de_documento_certificados: [
        {
            value: 1,
            label: 'CÉDULA',
        },
        {
            value: 2,
            label: 'CÉDULA EXTRANJERÍA',
        },
        {
            value: 3,
            label: 'IDENTIFICACIÓN TRIBUTARIA',
        },
    ],
    tipo_referenciado: [
        {
            value: 0,
            label: 'TITULAR',
        },
        {
            value: 1,
            label: 'CODEUDOR',
        },
    ],
    direccionComplementos: [
        {
            value: 'NORTE',
            label: 'NORTE',
        },
        {
            value: 'SUR',
            label: 'SUR',
        },
        {
            value: 'ESTE (ORI)',
            label: 'ESTE (ORI)',
        },
        {
            value: 'OESTE (OCC)',
            label: 'OESTE (OCC)',
        },
        {
            value: 'BIS',
            label: 'BIS',
        },
        {
            value: 'BIS NORTE',
            label: 'BIS NORTE',
        },
        {
            value: 'BIS SUR',
            label: 'BIS SUR',
        },
        {
            value: 'BIS ESTE (ORI)',
            label: 'BIS ESTE (ORI)',
        },
        {
            value: 'BIS OESTE (OCC)',
            label: 'BIS OESTE (OCC)',
        },
    ],
    enfermedades: [
        { value: 0, label: 'ENFERMEDADES CARDIOVASCULARES' },
        { value: 1, label: 'INFARTO DEL CORAZÓN' },
        { value: 2, label: 'ARRITMIAS' },
        { value: 3, label: 'HIPERTENSIÓN ARTERIAL' },
        { value: 4, label: 'COLESTEROL (TRATADO CON MEDICAMENTOS)' },
        { value: 5, label: 'TRIGLICÉRIDOS ALTOS (TRATADOS CON MEDICAMENTOS)' },
        { value: 6, label: 'LUPUS' },
        { value: 7, label: 'ISQUEMIA O TROMBOSIS CEREBRAL' },
        { value: 8, label: 'EPILEPSIA' },
        { value: 9, label: 'ENFISEMA (EPOC)' },
        { value: 10, label: 'BRONQUITIS CRÓNICA' },
        { value: 11, label: 'CÁNCER CON METÁSTASIS (AFECTA OTROS ÓRGANOS)' },
        { value: 12, label: 'CÁNCER SIN METÁSTASIS (NO AFECTA OTROS ÓRGANOS)' },
        { value: 13, label: 'CIRROSIS' },
        { value: 14, label: 'DERRAMES' },
        { value: 15, label: 'LEUCEMIA' },
        { value: 16, label: 'TUMORES MALIGNOS' },
        { value: 17, label: 'SIDA O VIH POSITIVO' },
        { value: 18, label: 'INSUFICIENCIA RENAL' },
        { value: 19, label: 'ESCLEROSIS MÚLTIPLE' },
        { value: 20, label: 'ARTRITIS REUMATOIDEA' },
        { value: 21, label: 'DIABETES' },
        { value: 22, label: 'PANCREATITIS' },
        { value: 23, label: 'TRANSTORNOS PSIQUIÁTRICOS' },
        { value: 24, label: 'HEPATITIS B O C' },
        { value: 25, label: 'RETARDO MENTAL' },
        { value: 26, label: 'COLITIS ULCERATIVA' },
        { value: 27, label: 'HIPERTIROIDISMO' },
        { value: 28, label: 'PARÁLISIS DIFERENTE A FACIAL' },
        { value: 29, label: 'DEFORMIDADES CORPORALES' },
        { value: 30, label: 'CEGUERA' },
        { value: 31, label: 'SORDERA TOTAL O PARCIAL' },
        { value: 32, label: 'HERNIA DE COLUMNA' },
        { value: 33, label: 'PÉRDIDA FUNCIONAL O ANATÓMICA' },
    ],
    no_yes: [
        {
            value: '0',
            label: 'NO',
        },
        {
            value: '1',
            label: 'SÍ',
        },
    ],
    tipo_persona: [
        {
            value: 1,
            label: 'CODEUDOR',
        },
        {
            value: 0,
            label: 'CÓNYUGE',
        },
    ],
};

export default options;
